/**
 * A animação do Otto: o logotipo se deforma, traço a traço, até virar o ícone (câmera, folha e balão de fala), e volta.
 * Nada some: cada traço do nome vira uma peça do ícone. Portada do quadro de design (`Animacao`), com os mesmos tempos e curvas.
 *
 * Dados puros, sem React. Cada forma tem os atributos de partida (o logotipo parado, o quadro 0) e as animações SMIL que a
 * levam ao ícone: `values` com um valor por `keyTimes`, e `keySplines` (um a menos) como curva entre eles. Os valores
 * `#0F1115` são a cor da tinta do logotipo: o componente troca pela cor que o fundo pede (branca no escuro).
 */
export const OTTO_ANIMATION_VIEWBOX = '-50 -22 164 114'
export const OTTO_ANIMATION_DURATION = 5
/** A cor da tinta do logotipo no arquivo de design: o que o componente troca por `ink`. */
export const OTTO_ANIMATION_INK = '#0F1115'

export const OTTO_ANIMATION_SHAPES = Object.freeze(
[
  {
    "tag": "rect",
    "attrs": {
      "x": "17",
      "y": "19",
      "width": "32",
      "height": "32",
      "rx": "8",
      "fill": "#0E97B8",
      "opacity": "0"
    },
    "animations": [
      {
        "attr": "x",
        "keyTimes": "0;0.2;0.52;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .25 1;0 0 1 1;.55 0 .25 1;0 0 1 1",
        "values": "17;17;-16.25;-16.25;17;17"
      },
      {
        "attr": "y",
        "keyTimes": "0;0.2;0.52;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .25 1;0 0 1 1;.55 0 .25 1;0 0 1 1",
        "values": "19;19;-14.25;-14.25;19;19"
      },
      {
        "attr": "width",
        "keyTimes": "0;0.2;0.52;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .25 1;0 0 1 1;.55 0 .25 1;0 0 1 1",
        "values": "32;32;98.5;98.5;32;32"
      },
      {
        "attr": "height",
        "keyTimes": "0;0.2;0.52;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .25 1;0 0 1 1;.55 0 .25 1;0 0 1 1",
        "values": "32;32;98.5;98.5;32;32"
      },
      {
        "attr": "rx",
        "keyTimes": "0;0.2;0.52;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .25 1;0 0 1 1;.55 0 .25 1;0 0 1 1",
        "values": "8;8;23.4;23.4;8;8"
      },
      {
        "attr": "opacity",
        "keyTimes": "0;0.2;0.4;0.84;0.96;1",
        "keySplines": "0 0 1 1;.4 0 .6 1;0 0 1 1;.4 0 .6 1;0 0 1 1",
        "values": "0;0;1;1;0;0"
      }
    ]
  },
  {
    "tag": "path",
    "attrs": {
      "fill": "#0F1115",
      "fill-rule": "evenodd",
      "d": "M40.5 10 C40.5 4 49.5 4 49.5 10 L49.5 46.5 C49.5 49 51.5 51 54 51 L64 51 L64 34.5 C64 26.5 70.5 20 78.5 20 L89 20 C97 20 103.5 26.5 103.5 34.5 L103.5 45.5 C103.5 53.5 97 60 89 60 L54 60 C46.5 60 40.5 54 40.5 46.5 L40.5 10 Z M78.5 29 L89 29 C92 29 94.5 31.5 94.5 34.5 L94.5 45.5 C94.5 48.5 92 51 89 51 L73 51 L73 34.5 C73 31.5 75.5 29 78.5 29 Z"
    },
    "animations": [
      {
        "attr": "d",
        "keyTimes": "0;0.14;0.52;0.82;0.98;1",
        "keySplines": "0 0 1 1;.6 0 .2 1;0 0 1 1;.6 0 .2 1;0 0 1 1",
        "values": "M40.5 10 C40.5 4 49.5 4 49.5 10 L49.5 46.5 C49.5 49 51.5 51 54 51 L64 51 L64 34.5 C64 26.5 70.5 20 78.5 20 L89 20 C97 20 103.5 26.5 103.5 34.5 L103.5 45.5 C103.5 53.5 97 60 89 60 L54 60 C46.5 60 40.5 54 40.5 46.5 L40.5 10 Z M78.5 29 L89 29 C92 29 94.5 31.5 94.5 34.5 L94.5 45.5 C94.5 48.5 92 51 89 51 L73 51 L73 34.5 C73 31.5 75.5 29 78.5 29 Z;M40.5 10 C40.5 4 49.5 4 49.5 10 L49.5 46.5 C49.5 49 51.5 51 54 51 L64 51 L64 34.5 C64 26.5 70.5 20 78.5 20 L89 20 C97 20 103.5 26.5 103.5 34.5 L103.5 45.5 C103.5 53.5 97 60 89 60 L54 60 C46.5 60 40.5 54 40.5 46.5 L40.5 10 Z M78.5 29 L89 29 C92 29 94.5 31.5 94.5 34.5 L94.5 45.5 C94.5 48.5 92 51 89 51 L73 51 L73 34.5 C73 31.5 75.5 29 78.5 29 Z;M14 56.5 C14 56 14 55.5 14 55 L14 50 C10.7 50 8 47.3 8 44 L8 34 L8 20 C8 16.7 10.7 14 14 14 L35 14 C38 17 41 20 44 23 L44 44 C44 47.3 41.3 50 38 50 L21 50 C20 51 18.5 52.2 17.5 53.25 L14 56.5 Z M28 38 L28 38 C28 38 28 38 28 38 L28 38 C28 38 28 38 28 38 L28 38 L28 38 C28 38 28 38 28 38 Z;M14 56.5 C14 56 14 55.5 14 55 L14 50 C10.7 50 8 47.3 8 44 L8 34 L8 20 C8 16.7 10.7 14 14 14 L35 14 C38 17 41 20 44 23 L44 44 C44 47.3 41.3 50 38 50 L21 50 C20 51 18.5 52.2 17.5 53.25 L14 56.5 Z M28 38 L28 38 C28 38 28 38 28 38 L28 38 C28 38 28 38 28 38 L28 38 L28 38 C28 38 28 38 28 38 Z;M40.5 10 C40.5 4 49.5 4 49.5 10 L49.5 46.5 C49.5 49 51.5 51 54 51 L64 51 L64 34.5 C64 26.5 70.5 20 78.5 20 L89 20 C97 20 103.5 26.5 103.5 34.5 L103.5 45.5 C103.5 53.5 97 60 89 60 L54 60 C46.5 60 40.5 54 40.5 46.5 L40.5 10 Z M78.5 29 L89 29 C92 29 94.5 31.5 94.5 34.5 L94.5 45.5 C94.5 48.5 92 51 89 51 L73 51 L73 34.5 C73 31.5 75.5 29 78.5 29 Z;M40.5 10 C40.5 4 49.5 4 49.5 10 L49.5 46.5 C49.5 49 51.5 51 54 51 L64 51 L64 34.5 C64 26.5 70.5 20 78.5 20 L89 20 C97 20 103.5 26.5 103.5 34.5 L103.5 45.5 C103.5 53.5 97 60 89 60 L54 60 C46.5 60 40.5 54 40.5 46.5 L40.5 10 Z M78.5 29 L89 29 C92 29 94.5 31.5 94.5 34.5 L94.5 45.5 C94.5 48.5 92 51 89 51 L73 51 L73 34.5 C73 31.5 75.5 29 78.5 29 Z"
      },
      {
        "attr": "fill",
        "keyTimes": "0;0.22;0.46;0.82;0.96;1",
        "keySplines": "0 0 1 1;.5 0 .5 1;0 0 1 1;.5 0 .5 1;0 0 1 1",
        "values": "#0F1115;#0F1115;#FFFFFF;#FFFFFF;#0F1115;#0F1115"
      }
    ]
  },
  {
    "tag": "path",
    "attrs": {
      "fill": "#0B4F61",
      "opacity": "0",
      "d": "M42 21V22.5A0.5 0.5 0 0 0 42.5 23H44Z"
    },
    "animations": [
      {
        "attr": "d",
        "keyTimes": "0;0.44;0.58;0.8;0.88;1",
        "keySplines": "0 0 1 1;.4 0 .2 1;0 0 1 1;.6 0 .4 1;0 0 1 1",
        "values": "M42 21V22.5A0.5 0.5 0 0 0 42.5 23H44Z;M42 21V22.5A0.5 0.5 0 0 0 42.5 23H44Z;M35 14V20A3 3 0 0 0 38 23H44Z;M35 14V20A3 3 0 0 0 38 23H44Z;M42 21V22.5A0.5 0.5 0 0 0 42.5 23H44Z;M42 21V22.5A0.5 0.5 0 0 0 42.5 23H44Z"
      },
      {
        "attr": "opacity",
        "keyTimes": "0;0.44;0.5;0.82;0.86;1",
        "keySplines": null,
        "values": "0;0;1;1;0;0"
      }
    ]
  },
  {
    "tag": "path",
    "attrs": {
      "fill": "#0F1115",
      "d": "M10 19.5 L54 19.5 C56.5 19.5 58.5 21.5 58.5 24 V24 C58.5 26.5 56.5 28.5 54 28.5 L10 28.5 C4 28.5 4 19.5 10 19.5 Z"
    },
    "animations": [
      {
        "attr": "d",
        "keyTimes": "0;0.18;0.5;0.82;0.98;1",
        "keySplines": "0 0 1 1;.6 0 .2 1;0 0 1 1;.6 0 .2 1;0 0 1 1",
        "values": "M10 19.5 L54 19.5 C56.5 19.5 58.5 21.5 58.5 24 V24 C58.5 26.5 56.5 28.5 54 28.5 L10 28.5 C4 28.5 4 19.5 10 19.5 Z;M10 19.5 L54 19.5 C56.5 19.5 58.5 21.5 58.5 24 V24 C58.5 26.5 56.5 28.5 54 28.5 L10 28.5 C4 28.5 4 19.5 10 19.5 Z;M47 27 L56 21.5 C57.3 20.8 58.5 21.6 58.5 23 V41 C58.5 42.4 57.3 43.2 56 42.5 L47 37 C47 37 47 27 47 27 Z;M47 27 L56 21.5 C57.3 20.8 58.5 21.6 58.5 23 V41 C58.5 42.4 57.3 43.2 56 42.5 L47 37 C47 37 47 27 47 27 Z;M10 19.5 L54 19.5 C56.5 19.5 58.5 21.5 58.5 24 V24 C58.5 26.5 56.5 28.5 54 28.5 L10 28.5 C4 28.5 4 19.5 10 19.5 Z;M10 19.5 L54 19.5 C56.5 19.5 58.5 21.5 58.5 24 V24 C58.5 26.5 56.5 28.5 54 28.5 L10 28.5 C4 28.5 4 19.5 10 19.5 Z"
      },
      {
        "attr": "fill",
        "keyTimes": "0;0.24;0.46;0.82;0.96;1",
        "keySplines": "0 0 1 1;.5 0 .5 1;0 0 1 1;.5 0 .5 1;0 0 1 1",
        "values": "#0F1115;#0F1115;#FFFFFF;#FFFFFF;#0F1115;#0F1115"
      }
    ]
  },
  {
    "tag": "g",
    "attrs": {
      "fill": "none",
      "stroke": "#0E97B8",
      "stroke-width": "3.6",
      "stroke-linecap": "round"
    },
    "animations": [
      {
        "attr": "opacity",
        "keyTimes": "0;0.14;0.3;0.86;0.98;1",
        "keySplines": "0 0 1 1;.5 0 .5 1;0 0 1 1;.5 0 .5 1;0 0 1 1",
        "values": "1;1;0;0;1;1"
      }
    ],
    "children": [
      {
        "d": "M77.5 35.5H90.5"
      },
      {
        "d": "M77.5 43H85.5"
      }
    ]
  },
  {
    "tag": "path",
    "attrs": {
      "fill": "none",
      "stroke": "#0F1115",
      "stroke-width": "9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-dasharray": "12.8 0 21.8 0 11.8 0",
      "d": "M19 10 L19 20 L19 30 L19 40 L19 48 C19 53 23 57 30 57"
    },
    "animations": [
      {
        "attr": "d",
        "keyTimes": "0;0.16;0.5;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .2 1;0 0 1 1;.55 0 .2 1;0 0 1 1",
        "values": "M19 10 L19 20 L19 30 L19 40 L19 48 C19 53 23 57 30 57;M19 10 L19 20 L19 30 L19 40 L19 48 C19 53 23 57 30 57;M22.6 30 L35.4 30 L14.6 36.6 L36.4 36.6 L14.6 43.2 C18.5 43.2 22.5 43.2 26.4 43.2;M22.6 30 L35.4 30 L14.6 36.6 L36.4 36.6 L14.6 43.2 C18.5 43.2 22.5 43.2 26.4 43.2;M19 10 L19 20 L19 30 L19 40 L19 48 C19 53 23 57 30 57;M19 10 L19 20 L19 30 L19 40 L19 48 C19 53 23 57 30 57"
      },
      {
        "attr": "stroke-dasharray",
        "keyTimes": "0;0.34;0.5;0.82;0.9;1",
        "keySplines": "0 0 1 1;.5 0 .3 1;0 0 1 1;.5 0 .5 1;0 0 1 1",
        "values": "12.8 0 21.8 0 11.8 0;12.8 0 21.8 0 11.8 0;12.8 21.82 21.8 22.78 11.8 60;12.8 21.82 21.8 22.78 11.8 60;12.8 0 21.8 0 11.8 0;12.8 0 21.8 0 11.8 0"
      },
      {
        "attr": "stroke-width",
        "keyTimes": "0;0.16;0.5;0.82;0.98;1",
        "keySplines": "0 0 1 1;.55 0 .2 1;0 0 1 1;.55 0 .2 1;0 0 1 1",
        "values": "9;9;3.2;3.2;9;9"
      },
      {
        "attr": "stroke",
        "keyTimes": "0;0.22;0.46;0.82;0.96;1",
        "keySplines": "0 0 1 1;.5 0 .5 1;0 0 1 1;.5 0 .5 1;0 0 1 1",
        "values": "#0F1115;#0F1115;#0E97B8;#0E97B8;#0F1115;#0F1115"
      }
    ]
  },
  {
    "tag": "circle",
    "attrs": {
      "cx": "-20",
      "cy": "40",
      "r": "20",
      "fill": "#FF4D4F"
    },
    "animations": [
      {
        "attr": "r",
        "keyTimes": "0;0.05;0.1;0.4;0.82;0.98;1",
        "keySplines": ".4 0 .6 1;.4 0 .6 1;.6 0 .2 1;0 0 1 1;.6 0 .2 1;0 0 1 1",
        "values": "20;22.5;20;3;3;20;20"
      },
      {
        "attr": "cx",
        "keyTimes": "0;0.1;0.4;0.82;0.98;1",
        "keySplines": "0 0 1 1;.6 0 .2 1;0 0 1 1;.6 0 .2 1;0 0 1 1",
        "values": "-20;-20;15.5;15.5;-20;-20"
      },
      {
        "attr": "cy",
        "keyTimes": "0;0.1;0.4;0.82;0.98;1",
        "keySplines": "0 0 1 1;.6 0 .2 1;0 0 1 1;.6 0 .2 1;0 0 1 1",
        "values": "40;40;30;30;40;40"
      }
    ]
  }
]
)
